export default "__VITE_ASSET__BPvb9fpL__"